import React, { useMemo, lazy, Suspense } from "react";
import { Route } from "react-router-dom";
import {
  AtsDashboard,
  Leads,
  AccountDetails,
  Campaigns,
  Jobs,
  Ats,
  JobDetails,
  Applicants,
  ApplicantDetails,
  // AtsSettings,
  ScheduleResumeMining,
  // AddUser,
  Prospects,
  AddCampaign,
  Marketplace,
  Vendors,
  RecruitmentCampaigns,
  Hotlist,
  PipelineCandidates,
  ClientSubmissions,
  FollowupInterview,
  ConfirmedOrStart,
  AllAccountDetails,
  RecruitmentInternalSubmissions,
  RecruitmentInterviewFollowup,
  RecruitmentConfirmedOrStarts,
  Help,
  Reports,
  MergeLeads,
  RecruitmentJobs,
  KultFetch,
  TicketDetail,
  MarketplaceSetup,
  CreateCampaign,
  Recruiters,
  Interview,
  Submissions,
  Placement,
  IncentiveDashboard,
  AddUser,
  AiJobDetails,
  PushDataToWorkforce,
  // Upgrade
} from "../pages";

import InnerMainLayoutAts from "../pages/Ats/_layout/InnerMainLayoutAts";
import { filterRoutes } from "../utils/moduleAccessUtils";
//import CandidatesAddNewCandidate from "../pages/Ats/BenchSales/Jobs/CandidatesAddNewCandidate";
import CandidatesAddNewCandidate from "../pages/BenchSales/Jobs/CandidatesAddNewCandidate";
import Candidates from "../pages/BenchSales/Candidates/Candidates";
import JobsBenchsales from "../pages/BenchSales/Jobs/JobsBenchsales";
import PriorityLeads from "../pages/Ats/PriorityLeads/PriorityLeads";
import LeadView from "../pages/Ats/PriorityLeads/Leads/LeadView";
import { getItem } from "../utils/localStorageUtils";

const AtsRoutes = ({ moduleAccess = {}, user = {} }) => {
  const loginUserData = user?.data || {};
  const portal = getItem("portal");
  const role = loginUserData?.role?.type ?? null;
  const userModule = loginUserData?.role?.module ?? null;
  const atsRouteConfig = [
    { path: "/ats/dashboard", element: <AtsDashboard />, id: "dashboard" },
    { path: "/ats/leads", element: <Leads />, id: "leads" },
    { path: "/ats/leads/merge-leads", element: <MergeLeads />, id: "leads" },
    {
      path: "/ats/account-details",
      element: <AccountDetails />,
      id: "accountdetails",
    },
    {
      path: "/ats/all-account-details",
      element: <AllAccountDetails />,
      id: "allaccountdetails",
    },
    {
      path: "/ats/bdm/priority-leads",
      element: <PriorityLeads />,
      id: "priorityleads",
    },
    {
      path: "/ats/bdm/priority-leads-view",
      element: <LeadView />,
      id: "priorityleadsview",
    },
    // {
    //   path: "/ats/all-account-details/:uiid",
    //   element: <AllAccountDetails />,
    //   id: "allaccountdetails",
    // },
    { path: "/ats/campaigns", element: <Campaigns />, id: "campaigns" },
    {
      path: "/ats/campaigns/add-campaign",
      element: <AddCampaign />,
      id: "campaignsaddcampaign",
    },
    { path: "/ats/jobs", element: <Jobs />, id: "jobs" },
    {
      path: "/ats/jobs/job-details",
      element: <JobDetails />,
      id: "jobsdetailsuiid",
    },
    {
      path: "/ats/jobs/ai-job-details",
      element: <AiJobDetails />,
      id: "aijobsdetailsuiid",
    },
    {
      path: "/ats/create-campaign",
      element: <CreateCampaign />,
      id: "createcampaign",
    },
    // {
    //   path: "/ats/jobs/job-details/:uiid",
    //   element: <JobDetails />,
    //   id: "jobsdetailsuiid",
    // },
    {
      path: "/ats/jobs/job-details/schedule-resume-mining",
      element: <ScheduleResumeMining />,
      id: "jobsjobdetailsscheduleresumemining",
    },
    { path: "/ats/prospects", element: <Prospects />, id: "prospects" },
    { path: "/ats/applicants", element: <Applicants />, id: "applicants" },
    {
      path: "/ats/applicants/applicant-details",
      element: <ApplicantDetails />,
      id: "applicantid",
    },
    // { path: "/ats/settings", element: <AtsSettings /> ,id:"settings"},
    { path: "/ats/settings/add-user", element: <AddUser />, id: "adduser" },
    // { path: "/ats/marketplace", element: <Marketplace />, id: "marketplace" },
    // {
    //   path: "/ats/marketplace/setup",
    //   element: <MarketplaceSetup />,
    //   id: "marketplace_setup",
    // },
    { path: "/ats/reports", element: <Reports />, id: "reports" },
    { path: "/ats/reports/ats", element: <Ats />, id: "reports_ats" },
    { path: "/ats/vendors", element: <Vendors />, id: "vendors" },
    {
      path: "/ats/recruitment/campaigns",
      element: <RecruitmentCampaigns />,
      id: "recruitmentcampaigns",
    },
    {
      path: "/ats/recruitment/jobs",
      element: <RecruitmentJobs />,
      id: "recruitmentjobs",
    },
    {
      path: "/ats/recruitment/internal-submissions",
      element: <RecruitmentInternalSubmissions />,
      id: "recruitmentinternalsubmissions",
    },
    {
      path: "/ats/recruitment/interview-followup",
      element: <RecruitmentInterviewFollowup />,
      id: "recruitmentinterviewfollowup",
    },
    {
      path: "/ats/recruitment/confirmed-start",
      element: <RecruitmentConfirmedOrStarts />,
      id: "recruitmentconfirmedstart",
    },
    // {
    //   path: "/ats/benchsales/candidates",
    //   element: <Candidates />,
    //   id: "benchsaleshotlist",
    // },
    // {
    //   path: "/ats/benchsales/candidates/add-new-candidate",
    //   element: <CandidatesAddNewCandidate />,
    //   id: "benchsalescandidatesaddnewcandidate",
    // },
    // {
    //   path: "/ats/benchsales/jobs",
    //   element: <JobsBenchsales />,
    //   id: "benchsaleskultfetch",
    // },

    // new added for submissions
    // {
    //   path: "/ats/benchsales/submissions",
    //   element: <Submissions />,
    //   id: "benchsalessubmission",
    // },
    // {
    //   path: "/ats/benchsales/recruiters",
    //   element: <Recruiters />,
    //   id: "benchsalesrecruiters",
    // },
    //new added interview

    // {
    //   path: "/ats/benchsales/interview",
    //   element: <Interview />,
    //   id: "benchsalesinterview",
    // },
    // {
    //   path: "/ats/benchsales/placements",
    //   element: <Placement/>,
    //   id: "benchsalesplacement",
    // },
    // {
    //   path: "/ats/benchsales/campaign",
    //   element: <BenchSalesCampaign />,
    //   id: "benchsalescampaign",
    // },
    // {
    //   path: "/ats/benchsales/jobs",
    //   element: <KultFetch />,
    //   id: "benchsalesjobs",
    // },
    {
      path: "/ats/bdm/pipeline-candidates",
      element: <PipelineCandidates />,
      id: "pipelinecandidates",
    },
    {
      path: "/ats/bdm/client-submissions",
      element: <ClientSubmissions />,
      id: "clientsubmissions",
    },
    {
      path: "/ats/bdm/followup-interviews",
      element: <FollowupInterview />,
      id: "followupinterviews",
    },
    {
      path: "/ats/bdm/confirmed-starts",
      element: <ConfirmedOrStart />,
      id: "confirmedstarts",
    },
    {
      path: "/ats/bdm/push-data-to-workforce",
      element: <PushDataToWorkforce />,
      id: "pushdatatoworkforce",
    },

    { path: "/ats/help", element: <Help />, id: "help" },
    {
      path: "/ats/help/ticket-details",
      element: <TicketDetail />,
      id: "ticket_detail",
    },
  ];
  const accessibleRoutes = filterRoutes({
    routes: atsRouteConfig,
    modules: moduleAccess,
    role,
    userModule,
    portal,
  });
  return (
    // <>
    //   <Route element={<InnerMainLayoutAts />}>
    //   <Route path="/ats/dashboard" element={<AtsDashboard />} />
    //   <Route path="/ats/leads" element={<Leads />} />
    //   <Route path="/ats/account-details" element={<AccountDetails />} />
    //   <Route
    //     path="/ats/all-account-details"
    //     element={<AllAccountDetails />}
    //   />
    //   <Route path="/ats/campaigns" element={<Campaigns />} />
    //   <Route path="/ats/campaigns/add-campaign" element={<AddCampaign />} />
    //   {/* //////Jobs///////// */}
    //   <Route path="/ats/jobs" element={<Jobs />} />
    //   <Route path="/ats/prospects" element={<Prospects />} />
    //   {/* <Route path="/ats/jobs/job-details" element={<JobDetails />} /> */}
    //   <Route path="/ats/jobs/job-details/:uiid" element={<JobDetails />} />
    //   <Route
    //     path="/ats/jobs/job-details/schedule-resume-mining"
    //     element={<ScheduleResumeMining />}
    //   />
    //   {/* //////Jobs End///////// */}
    //   <Route path="/ats/applicants" element={<Applicants />} />
    //   <Route
    //     path="/ats/applicants/applicant-details"
    //     element={<ApplicantDetails />}
    //   />
    //   {/* Add more ATS-specific routes here as needed */}
    //   <Route path="/ats/settings" element={<AtsSettings />} />
    //   {/* <Route path="/ats/settings#access-control" element={<UserTeams />} /> */}
    //   <Route path="/ats/settings/add-user" element={<AddUser />} />

    //   <Route path="/ats/marketplace" element={<Marketplace />} />
    //   <Route path="/ats/vendors" element={<Vendors />} />
    //   <Route
    //     path="/ats/recruitment/campaigns"
    //     element={<RecruitmentCampaigns />}
    //   />
    //   <Route
    //     path="/ats/recruitment/internal-submissions"
    //     element={<RecruitmentInternalSubmissions />}
    //   />
    //   <Route
    //     path="/ats/recruitment/Interview-followup"
    //     element={<RecruitmentInterviewFollowup />}
    //   />
    //   <Route
    //     path="/ats/recruitment/confirmed-start"
    //     element={<RecruitmentConfirmedOrStarts />}
    //   />
    //   <Route path="/ats/benchsales/hotlist" element={<Hotlist />} />
    //   <Route
    //     path="/ats/benchsales/campaign"
    //     element={<BenchSalesCampaign />}
    //   />
    //   <Route
    //     path="/ats/bdm/pipeline-candidates"
    //     element={<PipelineCandidates />}
    //   />
    //   <Route
    //     path="/ats/bdm/client-submissions"
    //     element={<ClientSubmissions />}
    //   />
    //   <Route
    //     path="/ats/bdm/followup-interview"
    //     element={<FollowupInterview />}
    //   />
    //   <Route path="/ats/bdm/confirmed-start" element={<ConfirmedOrStart />} />
    //   <Route path="/ats/help" element={<Help />} />
    // </Route>
    // </>
    <>
      <Route element={<InnerMainLayoutAts />}>
        {accessibleRoutes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
      </Route>
    </>
  );
};

export default AtsRoutes;
